module.exports = __webpack_public_path__ + "fonts/OpenSans-MediumItalic.25b4a3b7.eot";